"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Config_1 = require("../Config");
var Utilities_1 = require("../Utilities");
var MockService = (function () {
    function MockService() {
    }
    MockService.prototype.initialize = function (context, loader) {
        var _this = this;
        if ((csod.pageDefinition.hasOwnProperty('mocks') && csod.pageDefinition.mocks.enabled && csod.context.debug)
            || (Utilities_1.getCookie('p_mock_service') === 'enabled' && csod.pageDefinition.mocks.enabled)) {
            var services_1 = csod.pageDefinition.mocks.services ? csod.pageDefinition.mocks.services : [];
            return loader.injectAsset('core-ui', 'sinon', 'script')
                .then(function () {
                if (csod.pageDefinition.mocks.hasOwnProperty('type') && csod.pageDefinition.mocks.type === 'js') {
                    var scriptPromises_1 = [];
                    services_1.forEach(function (service) {
                        scriptPromises_1.push(Utilities_1.appendScript("" + context.basePath + Config_1.config.paths.mocks + service + ".js"));
                    });
                    return Promise.all(scriptPromises_1)
                        .then(function () {
                        var allServices = [];
                        Object.keys(csod._services || {}).forEach(function (key) {
                            allServices = allServices.concat(csod._services[key]());
                        });
                        return allServices;
                    });
                }
                else {
                    var servicePromises = [];
                    var responses_1 = [];
                    for (var i = 0; i < services_1.length; i++) {
                        if (services_1[i]) {
                            servicePromises.push(csod.service.get("" + context.basePath + Config_1.config.paths.mocks + services_1[i] + ".json")
                                .then(function (data) {
                                responses_1 = responses_1.concat(data);
                            }));
                        }
                    }
                    return Promise.all(servicePromises)
                        .then(function () { return responses_1; });
                }
            })
                .then(function (responses) {
                _this.initializeSinon(responses);
            });
        }
        else {
            return Promise.resolve('No mocking service provided.');
        }
    };
    MockService.prototype.setTestMock = function (location) {
        var _this = this;
        return csod.service.get(location)
            .then(function (data) {
            _this.initializeSinon(data);
        });
    };
    MockService.prototype.initializeSinon = function (responses) {
        var server = sinon.fakeServer.create();
        server.autoRespond = true;
        server.autoRespondAfter = csod.pageDefinition.mocks
            ? (csod.pageDefinition.mocks.timeOut || 5)
            : 5;
        var _loop_1 = function (i) {
            var r = responses[i];
            var status_1 = r.status || 200;
            var headers = r.headers || {
                "Content-Type": "application/json"
            };
            server.respondWith(r.method, r.path, function (req) {
                var body = r.body;
                switch (typeof body) {
                    case 'object':
                        body = JSON.stringify(body);
                        break;
                    case 'function':
                        body = JSON.stringify(body(req));
                        break;
                    default:
                        break;
                }
                req.respond(status_1, headers, body);
            });
        };
        for (var i = 0; i < responses.length; i++) {
            _loop_1(i);
        }
        sinon.FakeXMLHttpRequest.useFilters = true;
        sinon.FakeXMLHttpRequest.addFilter(function (method, url, async, username, password) {
            var wloc = typeof window !== "undefined" ? window.location : { protocol: null, host: null };
            var rCurrLoc = new RegExp("^" + wloc.protocol + "//" + wloc.host);
            if (!/^https?:\/\//.test(url) || rCurrLoc.test(url)) {
                url = url.replace(rCurrLoc, "");
            }
            for (var l = server.responses.length, i = l - 1; i >= 0; i--) {
                var response = server.responses[i];
                var matchMethod = !response.method || response.method.toLowerCase() === method.toLowerCase();
                var matchUrl = !response.url || response.url === url || (typeof response.url.test === "function" && response.url.test(url));
                if (matchMethod && matchUrl) {
                    return false;
                }
            }
            return true;
        });
    };
    return MockService;
}());
exports.MockService = MockService;



//////////////////
// WEBPACK FOOTER
// ./src/MockService/index.ts
// module id = 67
// module chunks = 0